import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import NumberFormat from 'react-number-format';
import {
  Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';

import { createPickingReturnDocument } from '../../../app/store/actions/returnPickingOrder';
import OneClickButton from '../../../components/form/button';
import addNotification from '../../../components/notification';
import { PanelPage } from '../../../components/pages/pages';
import { Panel, PanelBody } from '../../../components/panel/panel';
import ProductsList from './productsList';

class PickingReturn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      outboundOrderId: '',
      branchCode: '',
      branchName: '',
      returnOrder: '',
      pickingOrder: '',
      loadNumber: '',
      returnDate: '',
      customerName: '',
      orderType: '',
      products: [],
      selectedCheckbox: {},
      outboundOrderProductIds: [],
      showSendIntegrationModal: false,
      showOriginModal: false,
      originProducts: [],
      originQuantities: {},
    };
  }

  async componentDidMount() {
    await this.detailOrder();
  }

  setValue = async (attr, value) => {
    this.setState({
      [`${attr}`]: value,
    });
  };

  detailOrder = async () => {
    const { orderSelected } = this.props;
    this.setState({
      outboundOrderId: orderSelected.outboundOrderId,
      branchCode: orderSelected.branchCode,
      branchName: `${orderSelected.branchCode} - ${orderSelected.branchName}`,
      returnOrder: `DEV${orderSelected.orderNumber}`,
      pickingOrder: orderSelected.orderNumber,
      loadNumber: orderSelected.loadNumber,
      returnDate: moment(orderSelected.pickStartAt).format('DD/MM/YYYY'),
      customerName: `${orderSelected.customerCode}-${orderSelected.customerName}`,
      orderType: orderSelected.orderType,
      products: orderSelected.products,
    });
  };

  createInput = (value, attr, label, placeholder, type = 'text', required, disabled) => (
    <div className="form-group p-2 text-left">
      <label htmlFor={attr}>{label}</label>
      <div className="input-group">
        <input
          type={type}
          className="form-control"
          value={value || ''}
          onChange={(e) => this.setValue(attr, e.target.value)}
          placeholder={disabled ? '' : placeholder}
          required={required}
          disabled={disabled}
        />
      </div>
    </div>
  );

  getSelectedReturnProducts = () => {
    const { outboundOrderProductIds, products } = this.state;
    return products
      .filter((product) => outboundOrderProductIds.includes(product.outboundOrderProductId.toString()))
      .map((product) => ({
        ...product,
        newPickedQuantity: product.newPickedQuantity !== undefined
          && product.newPickedQuantity !== null
          ? product.newPickedQuantity
          : product.pickedQuantity,
      }));
  };

  validateSelectedReturnProducts = (outboundProducts) => {
    if (!outboundProducts.length) {
      addNotification(
        'danger',
        I18n.t('BEE908' /* Devolução de Picking */),
        I18n.t('BEE1072' /* Nenhum produto selecionado ! */),
        'top-right',
      );
      return false;
    }

    const invalidQuantity = outboundProducts.find((product) => (
      parseFloat(product.newPickedQuantity || 0) > parseFloat(product.pickedQuantity)
    ));

    if (invalidQuantity) {
      addNotification(
        'danger',
        I18n.t('BEE908' /* Devolução de Picking */),
        I18n.t('BEE4561' /* A quantidade parcial não pode ser maior que a separada! */),
        'top-right',
      );
      return false;
    }

    const invalidZero = outboundProducts.find((product) => (
      parseFloat(product.newPickedQuantity || 0) <= 0
    ));

    if (invalidZero) {
      addNotification(
        'danger',
        I18n.t('BEE908' /* Devolução de Picking */),
        I18n.t('BEE2293' /* A quantidade tem que ser maior que 0 */),
        'top-right',
      );
      return false;
    }

    return true;
  };

  continueReturn = () => {
    const { manualConfirmPicking, status, integrated } = this.props.orderSelected;
    if (manualConfirmPicking && status === 6 && !integrated) {
      this.setState({ showOriginModal: false, showSendIntegrationModal: true });
      return;
    }
    this.pickingReturn();
  };

  confirmPickingReturn = async () => {
    const outboundProducts = this.getSelectedReturnProducts();
    if (!this.validateSelectedReturnProducts(outboundProducts)) {
      return;
    }

    const {
      outboundOrderId, returnOrder, branchCode,
    } = this.state;

    try {
      const preview = await this.props.createPickingReturnDocument(
        outboundProducts,
        outboundOrderId,
        returnOrder,
        branchCode,
        true,
        true,
      );

      if (preview && preview.success === false) {
        addNotification(
          'danger',
          I18n.t('BEE908' /* Devolução de Picking */),
          I18n.t('BEE1907' /* Não foi possível finalizar a devolução */),
          'top-right',
        );
        return;
      }

      if (preview && preview.requiresOriginSelection) {
        this.setState({
          showOriginModal: true,
          originProducts: preview.products || [],
          originQuantities: {},
        });
        return;
      }
    } catch (error) {
      const messageError = error.response && error.response.data
        && error.response.data.error && error.response.data.error.message;
      addNotification(
        'danger',
        I18n.t('BEE908' /* Devolução de Picking */),
        messageError || I18n.t('BEE1852' /* Não foi possível finalizar esta ação */),
        'top-right',
      );
      return;
    }

    this.continueReturn();
  };

  setOriginQuantity = (productId, documentId, value) => {
    const originQuantities = { ...this.state.originQuantities };
    const productQuantities = { ...(originQuantities[productId] || {}) };
    productQuantities[documentId] = value;
    originQuantities[productId] = productQuantities;
    this.setState({ originQuantities });
  };

  roundQuantity = (value) => {
    const number = parseFloat(value || 0);
    if (Number.isNaN(number)) {
      return 0;
    }
    return Number(number.toFixed(4));
  };

  confirmOriginSelection = () => {
    const { originProducts, originQuantities, products } = this.state;
    const originReturnsByProduct = {};

    for (let index = 0; index < originProducts.length; index += 1) {
      const selection = originProducts[index];
      const quantities = originQuantities[selection.outboundOrderProductId] || {};
      const originReturns = [];
      let total = 0;

      for (let originIndex = 0; originIndex < selection.origins.length; originIndex += 1) {
        const origin = selection.origins[originIndex];
        const roundedQuantity = this.roundQuantity(quantities[origin.id]);
        const availableQuantity = this.roundQuantity(origin.pickedQuantity);
        if (roundedQuantity < 0) {
          addNotification(
            'danger',
            I18n.t('BEE908' /* Devolução de Picking */),
            I18n.t('BEE2293' /* A quantidade tem que ser maior que 0 */),
            'top-right',
          );
          return;
        }
        if (roundedQuantity - availableQuantity > 0) {
          addNotification(
            'danger',
            I18n.t('BEE908' /* Devolução de Picking */),
            I18n.t('BEE4893' /* Quantidade devolvida é superior à quantidade separada do documento de origem */),
            'top-right',
          );
          return;
        }
        if (roundedQuantity > 0) {
          originReturns.push({
            outboundOrderLoadSimplifiedId: origin.id,
            quantity: roundedQuantity,
          });
          total = this.roundQuantity(total + roundedQuantity);
        }
      }

      if (this.roundQuantity(total) !== this.roundQuantity(selection.returnQuantity)) {
        addNotification(
          'danger',
          I18n.t('BEE908' /* Devolução de Picking */),
          I18n.t('BEE4895' /* A quantidade informada deve ser igual à quantidade da devolução */),
          'top-right',
        );
        return;
      }

      originReturnsByProduct[selection.outboundOrderProductId] = originReturns;
    }

    const productsWithOrigins = products.map((product) => {
      const originReturns = originReturnsByProduct[product.outboundOrderProductId];
      if (!originReturns) {
        return product;
      }
      return {
        ...product,
        originReturns,
      };
    });

    this.setState({
      products: productsWithOrigins,
      showOriginModal: false,
    }, () => this.continueReturn());
  };

  pickingReturn = async (sendIntegration = true) => {
    this.setState({ showSendIntegrationModal: false });
    const {
      outboundOrderProductIds, outboundOrderId, returnOrder, branchCode, products,
    } = this.state;
    const returnedProducts = products.reduce((accumulator, element) => {
      if (element.productStatus < 10) return accumulator + 1;
      return accumulator;
    }, 0);

    const outboundProducts = products
      .filter((product) => outboundOrderProductIds.includes(product.outboundOrderProductId.toString()))
      .map((product) => ({
        ...product,
        newPickedQuantity: product.newPickedQuantity ?? product.pickedQuantity, // Fallback
      }));

    const invalidQuantity = outboundProducts.find((product) => (
      parseFloat(product.newPickedQuantity || 0) > parseFloat(product.pickedQuantity)
    ));

    if (invalidQuantity) {
      addNotification(
        'danger',
        I18n.t('BEE908' /* Devolução de Picking */),
        I18n.t('BEE4561' /* A quantidade parcial não pode ser maior que a separada! */),
        'top-right',
      );
      return;
    }

    const invalidZero = outboundProducts.find((product) => (
      parseFloat(product.newPickedQuantity || 0) <= 0
    ));

    if (invalidZero) {
      addNotification(
        'danger',
        I18n.t('BEE908' /* Devolução de Picking */),
        I18n.t('BEE2293' /* A quantidade tem que ser maior que 0 */),
        'top-right',
      );
      return;
    }

    this.setState({ outboundOrderProductIds: [], selectedCheckbox: {} });

    if (outboundProducts.length) {
      try {
        const pickingReturn = await this.props.createPickingReturnDocument(
          outboundProducts,
          outboundOrderId,
          returnOrder,
          branchCode,
          sendIntegration,
        );

        if (pickingReturn && pickingReturn.success === false) {
          addNotification(
            'danger',
            I18n.t('BEE908' /* Devolução de Picking */),
            I18n.t('BEE1907' /* Não foi possível finalizar a devolução */),
            'top-right',
          );
        } else {
          addNotification(
            'success',
            I18n.t('BEE908' /* Devolução de Picking */),
            I18n.t('BEE1906' /* Devolução efetuada */),
            'top-right',
          );
          if (returnedProducts === outboundOrderProductIds.length) {
            this.props.resetForm();
          } else {
            await this.props.getDetailOrder(true);
            await this.detailOrder();
          }
        }
      } catch (error) {
        const messageError = error.response && error.response.data
          && error.response.data.error && error.response.data.error.message;

        if (messageError) {
          addNotification(
            'danger',
            I18n.t('BEE908' /* Devolução de Picking */),
            messageError,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE908' /* Devolução de Picking */),
            I18n.t('BEE1852' /* Não foi possível finalizar esta ação */),
            'top-right',
          );
        }
      }
    } else {
      addNotification(
        'danger',
        I18n.t('BEE908' /* Devolução de Picking */),
        I18n.t('BEE1072' /* Nenhum produto selecionado ! */),
        'top-right',
      );
    }
  };

  render() {
    const {
      branchName, returnOrder, pickingOrder, returnDate, customerName, orderType, products,
      loadNumber, showSendIntegrationModal,
    } = this.state;

    const { mainBranchData } = this.props.userLogged || {};

    return (
      <>
        <PanelPage
          noButton
          title={I18n.t('BEE908' /* Devolução de Picking */)}
          content={(
            <div className="slideUpTransition">
              <div className="row">
                <div className="col-xl-12">
                  <div>
                    <div className="row">
                      <div className="col-md-6">
                        {this.createInput(
                          branchName,
                          'branchName',
                          I18n.t('BEE145' /* Filial */),
                          '',
                          'text',
                          true,
                          true,
                        )}
                      </div>
                      <div className="col-md-3">
                        {this.createInput(
                          returnOrder,
                          'returnOrder',
                          I18n.t('BEE1905' /* Documento de Devolução */),
                          '',
                          'text',
                          false,
                          true,
                        )}
                      </div>
                      <div className="col-md-3">
                        {this.createInput(
                          returnDate,
                          'returnDate',
                          I18n.t('BEE1906' /* Data Transação */),
                          '',
                          'text',
                          false,
                          true,
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        {this.createInput(
                          customerName,
                          'customerName',
                          I18n.t('BEE50' /* Cliente */),
                          '',
                          'text',
                          true,
                          true,
                        )}
                      </div>
                      <div className="col-md-2">
                        {this.createInput(
                          pickingOrder,
                          'pickingOrder',
                          I18n.t('BEE1904' /* Documento de Saída */),
                          '',
                          'text',
                          false,
                          true,
                        )}
                      </div>
                      <div className="col-md-2">
                        {this.createInput(
                          loadNumber,
                          'loadNumber',
                          I18n.t('BEE4526' /* Carga */),
                          '',
                          'text',
                          false,
                          true,
                        )}
                      </div>
                      <div className="col-md-2">
                        {this.createInput(orderType, 'orderType', I18n.t('BEE200' /* Tipo */), '', 'text', false, true)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          footerContent={(
            <>
              <OneClickButton
                type="button"
                className="btn btn-120 btn-white p-5 m-5"
                onClick={() => this.props.resetForm()}
              >
                {I18n.t('BEE99' /* Cancelar */)}
              </OneClickButton>
              <OneClickButton
                type="button"
                className="btn btn-120 btn-primary p-5 m-5"
                onClick={() => this.confirmPickingReturn()}
              >
                {I18n.t('BEE100' /* Confirmar */)}
              </OneClickButton>
            </>
          )}

        />

        <Panel>
          <PanelBody>
            <ProductsList
              selectedCheckbox={this.state.selectedCheckbox}
              setSelectedCheckbox={(selectedCheckbox) => this.setState({ selectedCheckbox: { ...selectedCheckbox } })}
              outboundOrderProductIds={this.state.outboundOrderProductIds}
              setOutboundOrderProductIds={
                (outboundOrderProductIds) => this.setState({ outboundOrderProductIds: [...outboundOrderProductIds] })
              }
              products={products}
              setProducts={(productList) => this.setState({ products: [...productList] })}
              mainBranchData={mainBranchData}
            />
          </PanelBody>
        </Panel>
        <Modal
          size="lg"
          isOpen={this.state.showOriginModal}
          toggle={() => this.setState({ showOriginModal: false, originProducts: [], originQuantities: {} })}
        >
          <ModalHeader toggle={() => this.setState({ showOriginModal: false, originProducts: [], originQuantities: {} })}>
            {I18n.t('BEE4894' /* Selecione o documento original para a devolução de picking */)}
          </ModalHeader>
          <ModalBody>
            {(this.state.originProducts || []).map((selection) => (
              <div key={selection.outboundOrderProductId} className="m-b-20">
                <h5>
                  {`${selection.productCode} - ${I18n.t('BEE441' /* Quantidade */)}: ${selection.returnQuantity}`}
                </h5>
                <table className="table table-bordered widget-table widget-table-rounded">
                  <thead>
                    <tr className="text-center f-s-12">
                      <th>{I18n.t('BEE443' /* Documento */)}</th>
                      <th>{I18n.t('BEE50' /* Cliente */)}</th>
                      <th>{I18n.t('BEE1134' /* Quantidade Separada */)}</th>
                      <th>{I18n.t('BEE908' /* Devolução de Picking */)}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(selection.origins || []).map((origin) => {
                      const productQuantities = this.state.originQuantities[selection.outboundOrderProductId] || {};
                      return (
                        <tr className="text-center" key={origin.id}>
                          <td>{origin.orderNumber}</td>
                          <td>{origin.customerName || origin.customerCode}</td>
                          <td>{origin.pickedQuantity}</td>
                          <td>
                            <NumberFormat
                              className="form-control"
                              thousandSeparator="."
                              decimalSeparator=","
                              decimalScale={4}
                              value={productQuantities[origin.id] === 0 || productQuantities[origin.id]
                                ? productQuantities[origin.id]
                                : ''}
                              onValueChange={(values) => {
                                this.setOriginQuantity(
                                  selection.outboundOrderProductId,
                                  origin.id,
                                  values.floatValue,
                                );
                              }}
                              fixedDecimalScale
                              allowEmptyFormatting
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ))}
          </ModalBody>
          <ModalFooter>
            <OneClickButton
              type="button"
              className="btn btn-120 btn-primary p-5 m-5"
              onClick={() => this.confirmOriginSelection()}
            >
              {I18n.t('BEE1849' /* continuar */)}
            </OneClickButton>
          </ModalFooter>
        </Modal>
        {(showSendIntegrationModal
          && (
          <SweetAlert
            info
            closeOnClickOutside
            showCancel
            cancelBtnText={I18n.t('BEE173' /* Não */)}
            confirmBtnText={I18n.t('BEE172' /* Sim */)}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE4568' /* Deseja liberar o faturamento deste documento? */)}
            onConfirm={async () => this.pickingReturn()}
            onCancel={() => this.setState({ showSendIntegrationModal: false })}
            customButtons={(
              <>
                <OneClickButton
                  onClick={() => this.setState({ showSendIntegrationModal: false })}
                  type="button"
                  className="btn btn-default m-5"
                >
                  {I18n.t('BEE99' /* Cancelar */)}
                </OneClickButton>
                <OneClickButton
                  onClick={async () => this.pickingReturn(false)}
                  type="button"
                  className="btn btn-danger m-5"
                >
                  {I18n.t('BEE173' /* Não */)}
                </OneClickButton>
                <OneClickButton
                  onClick={async () => this.pickingReturn(true)}
                  type="button"
                  className="btn btn-primary m-5"
                >
                  {I18n.t('BEE100' /* Confirmar */)}
                </OneClickButton>
              </>
              )}
          />
          )
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userLogged: state.app.userLogged && state.app.userLogged,
});

const mapDispatchToProps = (dispatch) => ({
  createPickingReturnDocument: (
    outboundProducts,
    outboundOrderId,
    orderNumber,
    branchCode,
    sendIntegration,
    previewOnly,
  ) => dispatch(
    createPickingReturnDocument(
      outboundProducts,
      outboundOrderId,
      orderNumber,
      branchCode,
      sendIntegration,
      previewOnly,
    ),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PickingReturn));
